import { httpClient, type ID } from '#shared'

export async function deleteReaction(chatId: ID, messageId: ID, reactionId: ID) {
  await httpClient.delete(`chats/${chatId}/messages/${messageId}/reactions/${reactionId}`, { requireAuth: true })
}
